import { render } from "./selectCommon.vue?vue&type=template&id=2d4a60aa"
import script from "./selectCommon.vue?vue&type=script&lang=js"
export * from "./selectCommon.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/open-web-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__